<template>
  <tiptap-vuetify
    v-model="itemObject.content"
    :extensions="extensions"
    :toolbar-attributes="color"
  />
</template>

<script>
// import the component and the necessary extensions
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, CodeBlock, Paragraph, BulletList, OrderedList,
  ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'

export default {
  // specify in the list of components
  components: { TiptapVuetify },
  props: {
    itemObject: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: Object,
      default: () => ({
        color: 'grey darken-3',
        dark: true
      })
    }
  },
  data: () => ({
    // declare extensions you want to use
    extensions: [
      // you can specify options for extension
      new Heading({
        levels: [2, 3, 4, 5, 6]
      }),
      new Bold(),
      new Italic(),
      new Strike(),
      new Underline(),
      new Code(),
      new CodeBlock(),
      new Paragraph(),
      new BulletList(),
      new OrderedList(),
      new ListItem(),
      new Link(),
      new Blockquote(),
      new HardBreak(),
      new HorizontalRule(),
      new History()
    ]
  })
}
</script>
